import React, { useState, useMemo } from "react";
import { ExternalLink } from "lucide-react";
import { Button } from "../components/ui/button";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { motion, AnimatePresence } from "framer-motion";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";


/**
 * DATA DEMO (JSON)
 */
const demoList = [
  {
    "id": 1,
    "title": "Modern Architecture Studio",
    "description": "Showcase karya arsitektur modern dengan desain minimalis dan elegan.",
    "url": "https://corp1.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/1.png"
  },
  {
    "id": 2,
    "title": "Luxury Travel Experience",
    "description": "Website perjalanan mewah untuk destinasi eksklusif dan premium.",
    "url": "https://estate7.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/2.png"
  },
  {
    "id": 3,
    "title": "Creative Agency",
    "description": "Portal agensi kreatif untuk branding, marketing, dan digital campaign.",
    "url": "https://agency5.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/3.png"
  },
  {
    "id": 4,
    "title": "Fine Dining Restaurant",
    "description": "Website restoran fine dining dengan tampilan premium dan elegan.",
    "url": "https://event10.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/4.png"
  },
  {
    "id": 5,
    "title": "Eco Fashion Brand",
    "description": "Brand fashion ramah lingkungan dengan konsep modern dan berkelanjutan.",
    "url": "https://corp2.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/5.png"
  },
  {
    "id": 6,
    "title": "SaaS Dashboard",
    "description": "Dashboard aplikasi SaaS untuk monitoring data dan analitik bisnis.",
    "url": "https://tech2.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/6.png"
  },
  {
    "id": 7,
    "title": "Adventure Gear",
    "description": "Website produk outdoor dan perlengkapan petualangan.",
    "url": "https://factory9.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/7.png"
  },
  {
    "id": 8,
    "title": "Art Gallery",
    "description": "Galeri seni digital untuk pameran karya seniman kontemporer.",
    "url": "https://consult8.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/8.png"
  },
  {
    "id": 9,
    "title": "Coffee Roastery",
    "description": "Website coffee roastery dengan nuansa artisan dan storytelling.",
    "url": "https://ngo6.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/9.png"
  },
  {
    "id": 10,
    "title": "Photography Portfolio",
    "description": "Portofolio fotografi profesional dengan galeri visual penuh layar.",
    "url": "https://legal3.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/10.png"
  },
  {
    "id": 11,
    "title": "Task Manager App",
    "description": "Aplikasi manajemen tugas untuk mengatur pekerjaan, deadline, dan produktivitas dengan material design modern.",
    "url": "https://task11.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/11.png"
  },
  {
    "id": 12,
    "title": "Email Client App",
    "description": "Aplikasi email client dengan tampilan material design yang bersih dan fokus pada kemudahan pengelolaan pesan.",
    "url": "https://email12.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/12.png"
  },
  {
    "id": 13,
    "title": "Education Portal App",
    "description": "Portal edukasi digital untuk pembelajaran online, kursus, dan manajemen materi belajar.",
    "url": "https://edu13.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/13.png"
  },
  {
    "id": 14,
    "title": "Fitness Tracker App",
    "description": "Aplikasi fitness tracker untuk memantau aktivitas olahraga, kesehatan, dan progres kebugaran pengguna.",
    "url": "https://fitness14.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/14.png"
  },
  {
    "id": 15,
    "title": "E-Commerce App",
    "description": "Aplikasi e-commerce dengan pengalaman belanja modern, katalog produk, dan proses checkout yang user-friendly.",
    "url": "https://shop15.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/15.png"
  },
  {
    "id": 16,
    "title": "Finance Tracker App",
    "description": "Aplikasi pencatatan dan analisis keuangan untuk memonitor pemasukan dan pengeluaran secara visual.",
    "url": "https://finance16.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/16.png"
  },
  {
    "id": 17,
    "title": "Cloud Storage App",
    "description": "Aplikasi cloud storage untuk menyimpan, mengelola, dan berbagi file dengan desain material yang intuitif.",
    "url": "https://cloud17.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/17.png"
  },
  {
    "id": 18,
    "title": "Social Feed App",
    "description": "Aplikasi social feed untuk berbagi posting, interaksi pengguna, dan konten real-time.",
    "url": "https://social18.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/18.png"
  },
  {
    "id": 19,
    "title": "Recipe Finder App",
    "description": "Aplikasi pencarian resep makanan dengan kategori, detail masakan, dan tampilan visual menarik.",
    "url": "https://recipe19.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/19.png"
  },
  {
    "id": 20,
    "title": "Weather App",
    "description": "Aplikasi cuaca untuk menampilkan prakiraan, suhu, dan kondisi cuaca dengan UI material design.",
    "url": "https://weather20.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/20.png"
  },


  {
    "id": 21,
    "title": "Calculator Soft UI",
    "description": "Aplikasi kalkulator dengan tampilan soft UI yang halus dan modern.",
    "url": "https://calc21.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/21.png"
  },
  {
    "id": 22,
    "title": "Crypto Wallet Soft UI",
    "description": "Aplikasi dompet kripto dengan desain soft UI untuk transaksi aset digital yang aman.",
    "url": "https://crypto22.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/22.png"
  },
  {
    "id": 23,
    "title": "Fintech Dashboard Soft UI",
    "description": "Dashboard fintech dengan visual data keuangan dan tampilan soft UI modern.",
    "url": "https://fintech23.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/23.png"
  },
  {
    "id": 24,
    "title": "Fitness Tracker Soft UI",
    "description": "Aplikasi fitness tracker dengan desain soft UI untuk memantau aktivitas dan kesehatan.",
    "url": "https://fitness24.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/24.png"
  },
  {
    "id": 25,
    "title": "Login Screen Neumorphic",
    "description": "Tampilan login screen dengan konsep neumorphic yang elegan dan modern.",
    "url": "https://login25.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/25.png"
  },
  {
    "id": 26,
    "title": "Music Player Neumorphism",
    "description": "Aplikasi pemutar musik dengan desain neumorphism yang smooth dan estetik.",
    "url": "https://music26.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/26.png"
  },
  {
    "id": 27,
    "title": "Productivity Timer Soft UI",
    "description": "Aplikasi timer produktivitas untuk fokus kerja dengan tampilan soft UI.",
    "url": "https://timer27.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/27.png"
  },
  {
    "id": 28,
    "title": "Settings Panel Neumorphic",
    "description": "Panel pengaturan aplikasi dengan desain neumorphic yang bersih dan intuitif.",
    "url": "https://settings28.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/28.png"
  },
  {
    "id": 29,
    "title": "Smart Home Soft UI",
    "description": "Aplikasi smart home controller dengan konsep soft UI untuk kontrol perangkat rumah pintar.",
    "url": "https://smarthome29.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/29.png"
  },
  {
    "id": 30,
    "title": "Weather Dashboard Neumorphic",
    "description": "Dashboard cuaca dengan desain neumorphic untuk menampilkan prakiraan dan kondisi cuaca.",
    "url": "https://weather30.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/30.png"
  },
  {
    "id": 31,
    "title": "Architecture Portfolio",
    "description": "Website portofolio arsitektur dengan layout broken grid untuk menampilkan karya secara visual dan dinamis.",
    "url": "https://architecture31.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/31.png"
  },
  {
    "id": 32,
    "title": "Creative Agency",
    "description": "Website agensi kreatif dengan desain asymmetrical yang berani dan modern.",
    "url": "https://creative32.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/32.png"
  },
  {
    "id": 33,
    "title": "Experimental Art Gallery",
    "description": "Galeri seni eksperimental dengan tata letak bebas dan konsep visual yang artistik.",
    "url": "https://art33.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/33.png"
  },
  {
    "id": 34,
    "title": "Fashion Editorial",
    "description": "Website editorial fashion dengan layout asymmetrical yang stylish dan high-end.",
    "url": "https://fashion34.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/34.png"
  },
  {
    "id": 35,
    "title": "Gourmet Food Showcase",
    "description": "Website kuliner gourmet dengan tampilan broken grid yang menggugah selera.",
    "url": "https://food35.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/35.png"
  },
  {
    "id": 36,
    "title": "Indie Music Label",
    "description": "Website label musik indie dengan desain broken grid untuk branding yang unik.",
    "url": "https://indie36.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/36.png"
  },
  {
    "id": 37,
    "title": "Interior Design Studio",
    "description": "Website studio desain interior dengan layout asymmetrical yang elegan dan modern.",
    "url": "https://interior37.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/37.png"
  },
  {
    "id": 38,
    "title": "Personal Brand Portfolio",
    "description": "Website personal branding dengan layout broken grid yang ekspresif dan profesional.",
    "url": "https://personal38.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/38.png"
  },
  {
    "id": 39,
    "title": "Photography Portfolio",
    "description": "Website portofolio fotografi dengan layout asymmetrical untuk storytelling visual.",
    "url": "https://photo39.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/39.png"
  },
  {
    "id": 40,
    "title": "Tech Startup Website",
    "description": "Website startup teknologi dengan desain asymmetrical yang modern dan futuristik.",
    "url": "https://tech40.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/40.png"
  },
  {
    "id": 41,
    "title": "Ambient Wellness Experience",
    "description": "Website wellness dengan video background ambient untuk menciptakan suasana tenang dan immersive.",
    "url": "https://wellness41.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/41.png"
  },
  {
    "id": 42,
    "title": "Architecture Time-lapse Showcase",
    "description": "Website arsitektur dengan video time-lapse pembangunan sebagai elemen visual utama.",
    "url": "https://architecture42.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/42.png"
  },
  {
    "id": 43,
    "title": "Cinematic Adventure Header",
    "description": "Website petualangan dengan video header sinematik untuk pengalaman visual yang dramatis.",
    "url": "https://adventure43.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/43.png"
  },
  {
    "id": 44,
    "title": "Festival Energy Experience",
    "description": "Website event festival dengan video berenergi tinggi sebagai daya tarik utama pengunjung.",
    "url": "https://festival44.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/44.png"
  },
  {
    "id": 45,
    "title": "3D Watch Interactive Showcase",
    "description": "Showcase jam tangan 3D interaktif dengan kontrol rotasi dan detail produk real-time.",
    "url": "https://watch45.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/45.png"
  },
  {
    "id": 46,
    "title": "Interactive Car Configurator",
    "description": "Konfigurator mobil interaktif berbasis video untuk memilih model, warna, dan fitur kendaraan.",
    "url": "https://car46.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/46.png"
  },
  {
    "id": 47,
    "title": "Interactive Coffee Brewing Story",
    "description": "Pengalaman scroll interaktif yang menceritakan proses pembuatan kopi dari biji hingga seduhan.",
    "url": "https://coffee47.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/47.png"
  },
  {
    "id": 48,
    "title": "Gaming Hardware Interactive",
    "description": "Website gaming hardware dengan video interaktif untuk menampilkan performa dan detail produk.",
    "url": "https://gaming48.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/48.png"
  },
  {
    "id": 49,
    "title": "Liquid Gradient Agency",
    "description": "Website agensi kreatif dengan elemen liquid gradient interaktif yang modern dan dinamis.",
    "url": "https://agency49.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/49.png"
  },
  {
    "id": 50,
    "title": "Sustainable Energy Video Header",
    "description": "Website energi berkelanjutan dengan video header untuk menonjolkan inovasi ramah lingkungan.",
    "url": "https://energy50.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/50.png"
  },
  {
    "id": 51,
    "title": "Developer Portfolio Interactions",
    "description": "Website portofolio developer dengan interaksi halus dan animasi yang memperkuat personal branding.",
    "url": "https://dev51.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/51.png"
  },
  {
    "id": 52,
    "title": "Fintech Micro-Interactions Dashboard",
    "description": "Dashboard fintech dengan micro-interactions untuk meningkatkan kejelasan dan pengalaman pengguna.",
    "url": "https://fintech52.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/52.png"
  },
  {
    "id": 53,
    "title": "Food App Delightful UI",
    "description": "Aplikasi makanan dengan UI yang menyenangkan dan animasi interaktif di setiap aksi pengguna.",
    "url": "https://food53.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/53.png"
  },
  {
    "id": 54,
    "title": "Gamified LMS Interactions",
    "description": "Learning Management System dengan elemen gamifikasi dan micro-interactions yang engaging.",
    "url": "https://lms54.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/54.png"
  },
  {
    "id": 55,
    "title": "Retail Store Micro-Interactions",
    "description": "Website retail dengan micro-interactions untuk navigasi produk dan pengalaman belanja yang smooth.",
    "url": "https://retail55.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/55.png"
  },
  {
    "id": 56,
    "title": "Rhythmic Player Micro UI",
    "description": "Music player dengan micro UI ritmis yang sinkron dengan interaksi dan alur musik.",
    "url": "https://player56.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/56.png"
  },
  {
    "id": 57,
    "title": "SaaS Onboarding Interactions",
    "description": "Pengalaman onboarding SaaS dengan animasi interaktif untuk membantu pengguna baru memahami fitur.",
    "url": "https://saas57.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/57.png"
  },
  {
    "id": 58,
    "title": "Social Feed Expressive UI",
    "description": "Aplikasi social feed dengan UI ekspresif dan animasi interaksi real-time.",
    "url": "https://social58.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/58.png"
  },
  {
    "id": 59,
    "title": "Task Tool Smooth Transitions",
    "description": "Aplikasi task management dengan transisi halus untuk meningkatkan fokus dan produktivitas.",
    "url": "https://task59.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/59.png"
  },
  {
    "id": 60,
    "title": "Weather App Dynamic UI",
    "description": "Aplikasi cuaca dengan UI dinamis yang berubah sesuai kondisi dan waktu secara real-time.",
    "url": "https://weather60.ghandiva.biz.id",
    "category": "Mobile App",
    "image": "/assets/demo/60.png"
  },

  {
    "id": 61,
    "title": "8-Bit Arcade Retro",
    "description": "Website bergaya arcade 8-bit dengan visual pixel art dan nuansa game retro klasik.",
    "url": "https://retro61.ghandiva.biz.id",
    "category": "Web",
    "image": "/assets/demo/61.png"
  },
  {
    "id": 62,
    "title": "70s Vinyl Retro Shop",
    "description": "Toko vinyl online dengan estetika retro tahun 70-an yang hangat dan penuh karakter analog.",
    "url": "https://vinyl62.ghandiva.biz.id",
    "category": "E-Commerce",
    "image": "/assets/demo/62.png"
  },
  {
    "id": 63,
    "title": "90s Nostalgia Personal Site",
    "description": "Website personal bernuansa nostalgia 90-an dengan gaya web klasik dan elemen playful.",
    "url": "https://nostalgia63.ghandiva.biz.id",
    "category": "Personal",
    "image": "/assets/demo/63.png"
  },
  {
    "id": 64,
    "title": "Anti-Design Agency Site",
    "description": "Website agensi dengan konsep anti-design yang berani, eksperimental, dan menantang standar UI.",
    "url": "https://antidesign64.ghandiva.biz.id",
    "category": "Agency",
    "image": "/assets/demo/64.png"
  },
  {
    "id": 65,
    "title": "Concrete Architecture Brutalism",
    "description": "Website arsitektur dengan gaya brutalism yang menonjolkan struktur beton dan tipografi tegas.",
    "url": "https://brutal65.ghandiva.biz.id",
    "category": "Architecture",
    "image": "/assets/demo/65.png"
  },
  {
    "id": 66,
    "title": "Digital Art Brutalism",
    "description": "Galeri seni digital dengan pendekatan brutalist yang kasar, kontras, dan ekspresif.",
    "url": "https://art66.ghandiva.biz.id",
    "category": "Art & Design",
    "image": "/assets/demo/66.png"
  },
  {
    "id": 67,
    "title": "Impact News Brutalist",
    "description": "Portal berita dengan desain brutalist untuk menyampaikan informasi secara kuat dan langsung.",
    "url": "https://news67.ghandiva.biz.id",
    "category": "Media",
    "image": "/assets/demo/67.png"
  },
  {
    "id": 68,
    "title": "Synthwave Brutalist Event",
    "description": "Website event synthwave dengan kombinasi visual neon retro dan layout brutalist.",
    "url": "https://event68.ghandiva.biz.id",
    "category": "Event",
    "image": "/assets/demo/68.png"
  },
  {
    "id": 69,
    "title": "Urban Brutalist Portfolio",
    "description": "Portofolio kreatif dengan gaya urban brutalism yang mentah dan berkarakter kuat.",
    "url": "https://portfolio69.ghandiva.biz.id",
    "category": "Portfolio",
    "image": "/assets/demo/69.png"
  },
  {
    "id": 70,
    "title": "Vaporwave Retail Hub",
    "description": "Platform retail dengan estetika vaporwave yang surreal, neon, dan bernuansa retro-futuristik.",
    "url": "https://vapor70.ghandiva.biz.id",
    "category": "E-Commerce",
    "image": "/assets/demo/70.png"
  },
  {
    "id": 71,
    "title": "Swadaya Tridaya Sertifikasi",
    "description": "Website lembaga sertifikasi dan pelatihan profesional untuk peningkatan kompetensi SDM.",
    // "url": "https://swadayatridaya.great-site.net",
    "url": "https://swadayatridaya.com/",
    "category": "Web",
    "image": "/assets/demo/71.png"
  },
  {
    "id": 72,
    "title": "Desa Export Indonesia",
    "description": "Platform digital pemberdayaan UMKM dan desa untuk menembus pasar ekspor global.",
    "url": "https://desaexport.id/",
    "category": "Web",
    "image": "/assets/demo/72.png"
  },
  {
    "id": 73,
    "title": "Pasompe Digital Platform",
    "description": "Website komunitas dan layanan digital dengan fokus kolaborasi dan inovasi lokal.",
    "url": "https://pasompe.ghandiva.biz.id/",
    "category": "Web",
    "image": "/assets/demo/73.png"
  },
  {
    "id": 74,
    "title": "Jumpa Virtual",
    "description": "Platform layanan pertemuan dan interaksi virtual untuk kebutuhan bisnis, edukasi, dan komunitas.",
    "url": "https://jumpavirtual.my.id/",
    "category": "Web",
    "image": "/assets/demo/74.png"
  }


];


const highlightProjects = demoList.filter(item =>
  [72, 71, 73, 74].includes(item.id)
);

const PLACEHOLDER =
  "https://dummyimage.com/600x400/e5e7eb/6b7280&text=No+Preview";

export default function Demo() {
  const [activeCategory, setActiveCategory] = useState("All");

  // ===== CATEGORY + COUNT =====
  const categories = useMemo(() => {
    const counts = demoList.reduce((acc, item) => {
      acc[item.category] = (acc[item.category] || 0) + 1;
      return acc;
    }, {});

    return [
      { name: "All", count: demoList.length },
      ...Object.entries(counts).map(([name, count]) => ({
        name,
        count,
      })),
    ];
  }, []);

  // ===== FILTERED DATA =====
  const filteredList = useMemo(() => {
    if (activeCategory === "All") return demoList;
    return demoList.filter(item => item.category === activeCategory);
  }, [activeCategory]);

  return (
    <div className="min-h-screen bg-white py-20">
      <div className="container mx-auto px-6 lg:px-8">

        {/* ================= HEADER ================= */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Demo Project <span className="text-gray-700">Ghandiva</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Beberapa contoh project dan demo website yang telah kami kerjakan
          </p>
        </div>

        {/* ================= FILTER ================= */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {categories.map(cat => (
            <motion.button
              key={cat.name}
              onClick={() => setActiveCategory(cat.name)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className={`px-5 py-2 rounded-full text-sm font-medium border transition
                ${
                  activeCategory === cat.name
                    ? "bg-gray-900 text-white border-gray-900"
                    : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
                }`}
            >
              {cat.name}
              <span className="ml-2 text-xs opacity-70">
                ({cat.count})
              </span>
            </motion.button>
          ))}
        </div>

        {/* ================= RESULT COUNT ================= */}
        <div className="text-center mb-12 text-gray-600">
          Menampilkan{" "}
          <span className="font-semibold text-gray-900">
            {filteredList.length}
          </span>{" "}
          dari{" "}
          <span className="font-semibold text-gray-900">
            {demoList.length}
          </span>{" "}
          project
        </div>

        {/* ================= HIGHLIGHT PROJECT (PREMIUM UI) ================= */}
<div className="mb-32">
  <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
    ⭐ Highlight Project
  </h2>

  <Swiper
    modules={[Autoplay, Navigation, Pagination]}
    spaceBetween={32}
    slidesPerView={1}
    loop
    centeredSlides
    autoplay={{ delay: 4000, disableOnInteraction: false }}
    navigation
    pagination={{ clickable: true }}
    breakpoints={{
      640: { slidesPerView: 1.2 },
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 2.8 },
    }}
    className="pb-14"
  >
    {highlightProjects.map((item) => (
      <SwiperSlide key={item.id}>
        <div className="group relative h-[420px] rounded-3xl overflow-hidden shadow-xl">

          {/* IMAGE */}
          <img
            src={item.image || PLACEHOLDER}
            alt={item.title}
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
            onError={(e) => (e.currentTarget.src = PLACEHOLDER)}
          />

          {/* GRADIENT OVERLAY */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-90" />

          {/* CONTENT */}
          <div className="relative z-10 h-full flex flex-col justify-end p-8">
            <span className="mb-3 w-fit px-4 py-1 text-xs rounded-full bg-white/20 text-white backdrop-blur">
              {item.category}
            </span>

            <h3 className="text-2xl font-bold text-white mb-3">
              {item.title}
            </h3>

            <p className="text-gray-200 mb-6 line-clamp-2 max-w-md">
              {item.description}
            </p>

            <Button
              className="w-fit bg-white text-gray-900 hover:bg-gray-100"
              onClick={() =>
                window.open(item.url, "_blank", "noopener,noreferrer")
              }
            >
              <ExternalLink className="w-4 h-4 mr-2" />
              Lihat Web
            </Button>
          </div>
        </div>
      </SwiperSlide>
    ))}
  </Swiper>
</div>


        {/* ================= GRID (ANIMATED) ================= */}
        <motion.div layout className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          <AnimatePresence mode="popLayout">
            {filteredList.map(item => (
              <motion.div
                key={item.id}
                layout
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.25, ease: "easeOut" }}
                className="group rounded-2xl border border-gray-200 bg-gray-50 hover:bg-white hover:shadow-xl transition overflow-hidden"
              >
                <div className="h-48 overflow-hidden">
                  <img
                    src={item.image || PLACEHOLDER}
                    alt={item.title}
                    className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => (e.currentTarget.src = PLACEHOLDER)}
                  />
                </div>

                <div className="p-6">
                  <span className="text-xs inline-block mb-2 px-3 py-1 rounded-full bg-gray-100">
                    {item.category}
                  </span>

                  <h3 className="text-xl font-semibold mb-2">
                    {item.title}
                  </h3>

                  <p className="text-gray-600 mb-6">
                    {item.description}
                  </p>

                  <Button
                    variant="outline"
                    onClick={() =>
                      window.open(item.url, "_blank", "noopener,noreferrer")
                    }
                  >
                    <ExternalLink className="w-4 h-4 mr-2" />
                    Lihat Web
                  </Button>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>

      </div>
    </div>
  );
}
